<template>
   <div>
       <div v-if="egg_name=='mona_lisa'">
           <p>
            Well, Rudolf II most likely never owned the famous Mona Lisa by Leonardo da Vinci.<br>
            But you can find the  <router-link to="/item/PrgB-1365">Lady with a White Dog</router-link> in 1621 Prague Inventory.
            </p>
           <img class="ui fluid image" src="/static/ee/rudolf-mona-lisa.jpg">
       </div>
       <div v-if="egg_name=='alessandro_scotta'">
           <p>
            Snad géniové zodiakální, snad osmapadesátá vyšší inteligence spikli se proti ubohému starci...
            </p>
           <img class="ui fluid image" src="/static/ee/scotta.jpg">
       </div>
        <div v-if="egg_name=='kyrie'">
           <p>
            Marry X-mas
            </p>
            <p style="text-align: center;"><img class="ui large image" style="display:unset;" src="/static/ee/xmas.jpg"></p>
            <audio controls autoplay>
              <source src="/static/ee/03 - Kyrie.mp3" type="audio/mp3">
            </audio>
       </div>
   </div>
</template>

<script>
    export default {
        props: ['egg_name'],
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TheEasterEgg.vue